/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_OpenInputs */

const en_admin_tickets_status_open = /** @type {(inputs: Admin_Tickets_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const zh_admin_tickets_status_open = /** @type {(inputs: Admin_Tickets_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待处理`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Admin_Tickets_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_open = /** @type {((inputs?: Admin_Tickets_Status_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_status_open(inputs)
	return zh_admin_tickets_status_open(inputs)
});
export { admin_tickets_status_open as "admin.tickets.status_open" }